import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled, useTheme } from '@mui/material/styles';
import * as React from 'react';

import { Outlet, Route, Routes } from 'react-router-dom';
import Dokumentenverwaltung from './SubPages/Dokumentenverwaltung/Dokumentenverwaltung';
import Faqs from './SubPages/FAQ/FAQ';
import Hausverwaltung from './SubPages/Hausverwaltung/Hausverwaltung';
import FileListe from '../../List/FileList';
import Nutzerverwaltung from './SubPages/Nutzerverwaltung/Nutzerverwaltung';
import UserOptions from './SubPages/UserOptions/UserOptions';

import Ads from '../Widgets/Advertisement/Ads';
import AppMain from '../AppBar/AppMain';
import Nutzergruppenverwaltung from './SubPages/Nutzergruppenverwaltung/Nutzergruppenverwaltung';

import { getSuperTokensRoutesForReactRouterDom } from 'supertokens-auth-react/ui';
import { EmailPasswordPreBuiltUI } from 'supertokens-auth-react/recipe/emailpassword/prebuiltui';
import { SessionAuth } from 'supertokens-auth-react/recipe/session';
import * as reactRouterDom from 'react-router-dom';
import { SpeicherUebersicht } from './SubPages/SpeicherUebersicht/SpeicherUebersicht';
import { ConfigureAds } from '../Widgets/Advertisement/ConfigureAds';
import Privacy from './SubPages/Privacy/Privacy';
import PrivacyEdit from './SubPages/Privacy/PrivacyEdit';
import { EmailVerificationPreBuiltUI } from 'supertokens-auth-react/recipe/emailverification/prebuiltui';
import { EmailVerificationClaim } from 'supertokens-auth-react/recipe/emailverification';
import UserDetails from './SubPages/UserDetails';
import { Logs } from './SubPages/Logging/Logging';
import DeleteFolder from './SubPages/Ordnerloeschen/DeleteFolder';
import Zeiterfassung from './SubPages/Zeiterfassung/Zeiterfassung';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import ZeiterfassungStempeln from './SubPages/Zeiterfassung/ZeiterfassungStempeln';
import Dashboard from './SubPages/Zeiterfassung/Dashboard/Dashboard';
import 'dayjs/locale/de';
import { ViewFileList } from '../../ViewFileList/ViewFileList';
import ContextProviderViewFileList from '../../ViewFileList/Contexts/ContectProviderViewFileList';
import { FileListDetails } from '../../ViewFileList/FileListDetails';
import ZeiterfassungStempelnUebersicht from './SubPages/Zeiterfassung/ZeiterfassungStempelnUebersicht';
import Urlaubsantrag from './SubPages/Urlaubsantrag/Urlaubsantrag';
import Startseite from './SubPages/Startseite';
import Tasks from './SubPages/Tasks/Tasks';
import RapporteRechnung from './SubPages/RapporteRechnung/RapporteRechnung';
import InvoiceSettings from './SubPages/RapporteRechnung/InvoiceSettings/InvoiceSettings';
interface IMainPagesProps { }
//

const VerifiedSessionAuth = ({ children }: { children: React.ReactNode }) => (
  <SessionAuth overrideGlobalClaimValidators={(globalValidators) => [...globalValidators, EmailVerificationClaim.validators.isVerified()]}>
    {children}
  </SessionAuth>
);

export default function MainPages(props: IMainPagesProps) {
  const theme = useTheme();
  const location = reactRouterDom.useLocation();
  const isAuthPage = location.pathname.startsWith('/auth');
  // ... DrawerHeader definition
  //const { setOpenDrawer } = React.useContext(AppBarContext)

  const drawerWidth = 340;

  const DrawerHeader = styled('div')(({ theme }) => ({
    // display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    justifyContent: 'flex-end',
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  }));

  return (
    // <ThemeProvider theme={theme.palette.main}>
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='de'>
        <AppMain>
          {!isAuthPage && <DrawerHeader theme={theme} />}
          <Routes key='TestThis'>
            {getSuperTokensRoutesForReactRouterDom(reactRouterDom, [
              EmailPasswordPreBuiltUI,
              EmailVerificationPreBuiltUI,
            ])}

            {/* <Route path="/login" element={<LoginPage />} />
          <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route path="/restorepassword" element={<RestorePassword />} /> */}
            <Route
              path='/terms-of-service'
              element={
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 1,
                    maxWidth: 'lg',
                    ml: 'auto',
                    mr: 'auto',
                  }}>
                  <Faqs />
                </Box>
              }
            />
            <Route path='/privacy-policy' element={<Privacy />} />
            <Route
              path='/privacy-policy-edit'
              element={
                <VerifiedSessionAuth>
                  <PrivacyEdit />
                </VerifiedSessionAuth>
              }
            />
            <Route
              path='/faqs'
              element={
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 1,
                    maxWidth: 'lg',
                    ml: 'auto',
                    mr: 'auto',
                  }}>
                  <Faqs />
                </Box>
              }
            />
            <Route
              path='/'
              element={
                <VerifiedSessionAuth>
                  <Startseite />
                </VerifiedSessionAuth>
              }
            />

            <Route
              path='/usergroupmanagement'
              element={
                <VerifiedSessionAuth>
                  <Nutzergruppenverwaltung />
                </VerifiedSessionAuth>
              }
            />
            <Route
              key={'TestRouteUsermanagement'}
              path='/usermanagement'
              element={
                <VerifiedSessionAuth>
                  <Nutzerverwaltung />
                </VerifiedSessionAuth>
              }
            />
            <Route
              path='/document_management'
              element={
                <VerifiedSessionAuth>
                  <Dokumentenverwaltung></Dokumentenverwaltung>
                </VerifiedSessionAuth>
              }
            />
            <Route
              path='/hausverwaltung'
              element={
                <VerifiedSessionAuth>
                  <Hausverwaltung />
                </VerifiedSessionAuth>
              }
            />
            <Route
              path='/cloud_storage'
              element={
                <VerifiedSessionAuth>
                  <SpeicherUebersicht />
                </VerifiedSessionAuth>
              }
            />
            <Route
              path='/configure_ads'
              element={
                <VerifiedSessionAuth>
                  <ConfigureAds />
                </VerifiedSessionAuth>
              }
            />
            <Route
              path='/logs'
              element={
                <VerifiedSessionAuth>
                  <Logs />
                </VerifiedSessionAuth>
              }
            />
            {/* <Route path="/documents" element={<FileListe />} /> */}
            <Route
              path='/user_options'
              element={
                <VerifiedSessionAuth>
                  <UserOptions />
                </VerifiedSessionAuth>
              }
            />
            <Route
              path='/deleteFolder'
              element={
                <VerifiedSessionAuth>
                  <DeleteFolder />
                </VerifiedSessionAuth>
              }
            />
            <Route
              path='/zeiterfassung/dashboard'
              element={
                <VerifiedSessionAuth>
                  <Dashboard />
                </VerifiedSessionAuth>
              }
            />
            <Route
              path='/zeiterfassung'
              element={
                <VerifiedSessionAuth>
                  <Zeiterfassung />
                </VerifiedSessionAuth>
              }
            />
            <Route
              path='/zeiterfassung/stempeln'
              element={
                <VerifiedSessionAuth>
                  <ZeiterfassungStempelnUebersicht />
                </VerifiedSessionAuth>
              }
            />
            <Route
              path='/zeiterfassung/stempeln/:bvhID'
              element={
                <VerifiedSessionAuth>
                  <ZeiterfassungStempeln />
                </VerifiedSessionAuth>
              }
            />
            <Route
              path='/zeiterfassung/urlaub'
              element={
                <VerifiedSessionAuth>
                  <Urlaubsantrag />
                </VerifiedSessionAuth>
              }
            />
            <Route
              path='/aufgaben'
              element={
                <VerifiedSessionAuth>
                  <Tasks />
                </VerifiedSessionAuth>
              }
            />
            <Route
              path='/rapporte-rechnung'
              element={
                <VerifiedSessionAuth>
                  <RapporteRechnung />
                </VerifiedSessionAuth>
              }
            />
            <Route
              path='/rapporte-rechnung/settings'
              element={
                <VerifiedSessionAuth>
                  <InvoiceSettings />
                </VerifiedSessionAuth>
              }
            />
            <Route
              path='/Datei_anzeige'
              element={
                <VerifiedSessionAuth>
                  <ViewFileList />
                </VerifiedSessionAuth>
              }
            />
          </Routes>
        </AppMain>
      </LocalizationProvider>
    </>
    // </ThemeProvider>
  );
}
